import React from 'react'
import { Box } from '@mui/material'

const Icon = ({ name, dim = null, ...props }) => {
    const dimProps = {}
    if (dim !== null) {
        const splitDim = dim.split(',')
        dimProps['width'] = splitDim[0]
        dimProps['height'] = splitDim[1]
    }

    const n = name.includes('.') ? name : `${name}.svg`

    return <Box component="img" src={`/images/${n}`} style={dimProps} {...props} />
}

export default Icon
